import { useState } from "react";
import ImageTag from "../reusebale/imageTag";
import ParagraphTag from "../reusebale/Paragraph";
import db from "../../db/index.json";
import { useSelector } from "react-redux";
import NoChat from "../reusebale/noChat";
import { motion } from "framer-motion";

const PrevShiftChat = ({ chats, onChatSelect, chatId }) => {
  const [activeTab, setActiveTab] = useState("all");
  const { chat } = db;

  function GetLastMessageTimeDifference(conversation, customerData) {
    if (!conversation || conversation.length === 0)
      return "No conversation found";

    const customerId = customerData._id;

    const customerMessages = conversation.filter(
      (msg) => msg.id === customerId
    );

    if (customerMessages.length === 0) return "No messages from this customer";

    const lastMessage = customerMessages[customerMessages.length - 1];
    const lastMessageTime = new Date(lastMessage.dateTime);
    const currentTime = new Date();

    const timeDifferenceMs = currentTime.getTime() - lastMessageTime.getTime();

    const minutes = Math.floor(timeDifferenceMs / (1000 * 60));
    const hours = Math.floor(timeDifferenceMs / (1000 * 60 * 60));
    const days = Math.floor(timeDifferenceMs / (1000 * 60 * 60 * 24));
    const months = Math.floor(days / 30); // Approximate

    if (months > 0) return `${months} month${months > 1 ? "s" : ""} ago`;
    if (days > 0) return `${days} day${days > 1 ? "s" : ""} ago`;
    if (hours > 0) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    if (minutes > 0) return `${minutes} min${minutes > 1 ? "s" : ""} ago`;

    return "Just now";
  }

  function GetLastMessage(conversation) {
    if (!conversation || conversation.length === 0) return "No messages found";

    // Get the last object from the array
    const lastMessageObject = conversation[conversation.length - 1];

    // Return the message property
    return lastMessageObject.message;
  }

  const sessionIdPastShift = useSelector(
    (state) => state.data.sessionIdPastShift
  );

  return (
    <div className="bg-[#0381CA]/5 rounded-2xl w-full flex flex-col items-center pt-3 h-full">
      {/* Tab content */}
      <div className="w-[90%] h-[74%] overflow-x-scroll mx-auto panelScroll pt-3">
        {activeTab === "all" ? (
          chats?.length > 0 ? (
            chats?.map((item, index) => (
              <motion.div
                key={index}
                onClick={
                  () => {
                    onChatSelect(item._id);
                  }
                  // dispatch(DataAction.selectedSessionIdAction(item._id))
                }
                className={`flex justify-between cursor-pointer mt-2 p-1 hover:bg-dangerColor/20 rounded-lg ${
                  chatId === item._id ? "bg-white" : ""
                }`}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
              >
                <div className="flex items-center justify-between w-[75%]">
                  <div className="w-[20%] rounded-full">
                    <ImageTag
                      path={item?.customerData?.profileImage}
                      classes="w-full rounded-full"
                      altText="logo"
                    />
                  </div>
                  <div className="w-[78%] cursor-pointer">
                    <ParagraphTag
                      content={`${item?.customerData?.firstName} ${item?.customerData?.lastName}`}
                      classes="text-black font-popinsSemiBold text-sm"
                    />
                    <ParagraphTag
                      content={GetLastMessage(item?.conversation)}
                      classes={`${
                        item.active ? "text-black" : "text-black/60"
                      } font-popinsMedium text-xs line-clamp-1`}
                    />
                  </div>
                </div>
                <div className="w-[25%] flex flex-col items-end justify-between text-end py-3">
                  <ParagraphTag
                    content={GetLastMessageTimeDifference(
                      item?.conversation,
                      item?.customerData
                    )}
                    classes="text-black/90 font-popinsMedium text-[10px]"
                  />
                  {item.active && (
                    <div className="size-2 rounded-full bg-green-500"></div>
                  )}
                </div>
              </motion.div>
            ))
          ) : (
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4 }}
            >
              <NoChat />
            </motion.div>
          )
        ) : (
          <motion.div
            className="text-gray-700"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.4 }}
          >
            Favorite content goes here
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default PrevShiftChat;
